import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import type {
  ReportDashboardLibraryComponent,
  ReportDashboardLibraryApiResponse,
} from '@core/reports-types';

@Injectable({ providedIn: 'root' })
export class ReportsLibraryComponentsHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchCollection(): Observable<{ componentTemplates: ReportDashboardLibraryComponent[] }> {
    return this.httpApi.get<ReportDashboardLibraryApiResponse>('/templates/components');
  }
}
